/* ==========================================================================
   custom-header-nav.js
   --------------------------------------------------------------------------
   FRAMELIN CUSTOM — NICHT TEIL VON "BE YOURS".

   Ergaenzt die vorhandenen <dropdown-menu> / <mega-menu> Elemente aus
   menu-dropdown.js um das, was dort fehlt:

     1. aria-expanded / aria-controls auf dem Ausloeser, synchron zum
        Zustand (das Theme schaltet nur die Klasse .is-active)
     2. Oeffnen per Tastatur (focusin) und Schliessen beim Verlassen
     3. Escape schliesst und gibt den Fokus an den Ausloeser zurueck
     4. Oeffnungsverzoegerung von 120ms beim Hovern, damit das Panel nicht
        aufklappt, wenn die Maus nur ueber die Zeile faehrt. Das Theme
        oeffnet Mega-Menues sonst ohne jede Verzoegerung.
     5. Der ganzflaechige Theme-Backdrop wird unterdrueckt. Er faerbt Header
        und Panel einheitlich ein und rechnet seine Hoehe als
        header.clientHeight + panel.clientHeight. Das Panel beginnt aber schon
        an der Unterkante von Zeile 2, also um das Padding des Headers weiter
        oben - der Backdrop stand dadurch 12px unter dem Panel hervor. Die
        Panels bringen ihren Hintergrund inzwischen selbst mit, der Header
        seinen ueber .header::before. Der Backdrop hat damit keine Aufgabe mehr.

   menu-dropdown.js bleibt unveraendert. Diese Datei laeuft danach (beide
   defer) und arbeitet ausschliesslich additiv: faellt sie aus, bleibt das
   Theme-Verhalten wie es war.
   ========================================================================== */

(function () {
  'use strict';

  var ROW = '.fl-header__nav-row';
  var OPEN_DELAY = 120;

  function init() {
    var row = document.querySelector(ROW);
    if (!row) return;

    var menus = Array.prototype.slice.call(
      row.querySelectorAll(':scope > .fl-header__nav-inner > .header__inline-menu > .list-menu > li > dropdown-menu, :scope > .fl-header__nav-inner > .header__inline-menu > .list-menu > li > mega-menu')
    );
    if (!menus.length) return;

    // Die Seite hat mehrere <nav> (Drawer und Desktop). Ohne Namen sind sie
    // in der Vorlesereihenfolge nicht auseinanderzuhalten.
    var nav = row.querySelector('.header__inline-menu');
    if (nav && !nav.getAttribute('aria-label') && row.dataset.navLabel) {
      nav.setAttribute('aria-label', row.dataset.navLabel);
    }

    var idCounter = 0;

    menus.forEach(function (menu) {
      var trigger = menu.querySelector('.header__menu-item--top');
      var panel = menu.querySelector(':scope > .list-menu-dropdown');
      if (!trigger) return;

      // ---- 1. ARIA -------------------------------------------------------
      if (panel) {
        if (!panel.id) {
          idCounter += 1;
          panel.id = 'fl-header-panel-' + idCounter;
        }
        trigger.setAttribute('aria-controls', panel.id);
        trigger.setAttribute('aria-expanded', 'false');
        trigger.setAttribute('aria-haspopup', 'true');

        // Zustand des Themes (Klasse .is-active) auf aria-expanded spiegeln.
        new MutationObserver(function () {
          var open = menu.classList.contains('is-active');
          trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

          // 5. Backdrop zuruecknehmen, sobald ein Panel aufgeht.
          if (open) {
            var backdrop = document.querySelector('.header-background');
            if (backdrop) backdrop.classList.remove('is-active');
          }
        }).observe(menu, { attributes: true, attributeFilter: ['class'] });
      }

      if (typeof menu.handleMouseover !== 'function') return;

      // ---- 4. Oeffnungsverzoegerung beim Hovern ---------------------------
      // mouseenter blubbert nicht, laeuft aber durch die Capture-Phase.
      // Hier wird es abgefangen, damit der Listener des Elements selbst
      // erst nach OPEN_DELAY laeuft.
      var timer = null;

      menu.addEventListener(
        'mouseenter',
        function (event) {
          if (event.target !== menu) return;
          event.stopPropagation();
          clearTimeout(timer);
          timer = setTimeout(function () {
            if (menu.matches(':hover')) menu.handleMouseover();
          }, OPEN_DELAY);
        },
        true
      );

      menu.addEventListener('mouseleave', function () {
        clearTimeout(timer);
      });

      // ---- 2. Tastatur ----------------------------------------------------
      // Fokus in den Ausloeser oder ins Panel oeffnet sofort (ohne Verzoegerung,
      // hier gibt es kein versehentliches Ueberfahren).
      // suppressFocus verhindert, dass das per Escape geschlossene Panel sofort
      // wieder aufgeht, wenn der Fokus dabei auf den Ausloeser zurueckspringt.
      menu.flSuppressFocus = false;

      menu.addEventListener('focusin', function () {
        clearTimeout(timer);
        if (menu.flSuppressFocus) return;
        if (!menu.classList.contains('is-active')) menu.handleMouseover();
      });

      menu.addEventListener('focusout', function (event) {
        if (menu.contains(event.relatedTarget)) return;
        if (typeof menu.close === 'function') menu.close();
      });
    });

    // ---- 3. Escape --------------------------------------------------------
    row.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;

      var open = menus.filter(function (menu) {
        return menu.classList.contains('is-active');
      });
      if (!open.length) return;

      event.stopPropagation();
      open.forEach(function (menu) {
        var trigger = menu.querySelector('.header__menu-item--top');
        var moveFocus = trigger && menu.contains(document.activeElement);

        menu.flSuppressFocus = true;
        if (typeof menu.close === 'function') menu.close();
        if (moveFocus) trigger.focus();
        setTimeout(function () {
          menu.flSuppressFocus = false;
        }, 0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
